import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { RotatingLines } from "react-loader-spinner";

const AgeForm = ({
  setSelectStep,
  setformData,
  expertise,
  consultField,
  storagePartnerId,
  doctorObj,
  patientsCategory = [],
  docId,
  loader = false
}) => {
  const { t } = useTranslation();
  const [selectType, setSelectType] = useState("adult");
  const [checkDocID, setCheckDocID] = useState(true);
  const handleSelect = (type) => {
    setSelectType(type);
  };


  useEffect(() => {  // if doctor have category of only child it will set default childer in select type
    if (docId && doctorObj && typeof doctorObj === 'object' && !Array.isArray(doctorObj)) {
      if (patientsCategory.length == 1 && patientsCategory[0] == "Children") {
        setSelectType("child")
      }
    }
  }, [doctorObj]);



  const handleContinue = () => {
    setformData((prev) => ({
      ...prev,
      ["age"]: selectType === "child" ? 1 : 18,
      ["consult"]: consultField,
    }));
    window.gtag("event", "new-request-age", {});
    setSelectStep(expertise === "null" ? "consult" : "reference");
  };
  useEffect(() => {
    setformData((prev) => ({
      ...prev,
      ["age"]: selectType === "child" ? 1 : 18,
      ["consult"]: consultField,
    }));
  }, [consultField]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);


  useEffect(() => {
    if (docId && doctorObj && typeof doctorObj === 'object' && !Array.isArray(doctorObj)) {
      setCheckDocID(Object.keys(doctorObj).length === 0);
    } else {
      setCheckDocID(true);
    }
  }, [doctorObj]);

  return (
    <>
      {
        loader && docId ?

          <div className="age-form">
            <RotatingLines
              strokeColor="grey"
              strokeWidth="5"
              animationDuration="0.75"
              width="72"
              visible={loader}
            />
          </div>
          :
          <div className="age-form">
            <h6>
              {t("Medical advice")} <span>{t("for")}</span>
            </h6>
            <div className="advise-type">
              {
                !docId || checkDocID ?
                  <>
                    <div
                      className={`advise-type-box ${selectType === "child" ? "selected" : ""
                        }`}
                      onClick={() => handleSelect("child")}
                    >
                      <p>{t("Child")}</p>
                    </div>
                    <div
                      className={`advise-type-box ${selectType === "adult" ? "selected" : ""
                        }`}
                      onClick={() => handleSelect("adult")}
                    >
                      <p>{t("Adult")}</p>
                    </div>
                  </>
                  :
                  <>
                    {patientsCategory.length >= 1 && patientsCategory.map((item, index) => {
                      if (item === "Children") {
                        return (<div key={index} className={`advise-type-box ${selectType === "child" ? "selected" : ""}`} onClick={() => handleSelect("child")}> <p>{t("Child")}</p> </div>)
                      } else if (item === "Adults") {
                        return (<div key={index} className={`advise-type-box ${selectType === "adult" ? "selected" : ""}`} onClick={() => handleSelect("adult")}> <p>{t("Adult")}</p></div>);
                      }
                      return null;
                    })
                    }
                  </>
              }
            </div>
            <div className="continue-btn">
              <Button onClick={handleContinue}>{t("Continue")}</Button>
              {storagePartnerId === "64d326cd869f4f8664538775" ? (
                <a
                  href="https://api.whatsapp.com/send?phone=972526001369"
                  target="_blank"
                >
                  {t(
                    "Didn't find the field you were looking for? It is written to us"
                  )}
                </a>
              ) : (
                <a href="https://www.hidoc.co.il/contact">
                  {t("We will be happy to help")}
                </a>
              )}
            </div>
          </div>
      }
    </>
  );
};
export default AgeForm;
